import React, { FC, JSX, useMemo, useState } from 'react';

import classNames from 'classnames';

import { EvErrorCard } from '@evinced-private/ui-common';

import { useConfiguration } from '../../providers/configurationProvider/ConfigurationProvider';
import { SiteScannerUiToggles } from '../../services/LocalTogglesService';
import { SiteScannerPopup } from '../common/site-scanner-popup/SiteScannerPopup';
import { IssueDetailsBlock } from '../issue-details-block/IssueDetailsBlock';

import './IssueDetailsPopup.scss';

interface IIssueDetailsPopupProps {
	issueId: string;
	scanId?: string;
	onClose?: () => void;
}

export const IssueDetailsPopup: FC<IIssueDetailsPopupProps> = ({
	issueId,
	onClose,
	scanId
}: IIssueDetailsPopupProps) => {
	const [error, setError] = useState(null);
	const [title, setTitle] = useState(null);
	const { getToggle } = useConfiguration();
	const enableAzureIntegration = getToggle(SiteScannerUiToggles.ENABLE_AZURE_INTEGRATION);

	const classes: string = classNames(error ? 'error-popup' : 'issue-details-popup', {
		'azure-popup': enableAzureIntegration
	});

	const issueDetailsBlockComponent = useMemo((): JSX.Element => {
		return (
			<IssueDetailsBlock
				issueId={issueId}
				scanId={scanId}
				setError={setError}
				setTitle={setTitle}
			/>
		);
	}, [scanId, issueId]);

	return (
		<div>
			<SiteScannerPopup
				isOpen
				title={error ? 'Error' : title}
				className={classes}
				isBgTransparent
				isCentered={!!error}
				isControlled
				onClose={() => {
					setError(false);
					onClose();
				}}
				popupWidth="unset"
			>
				{error ? (
					<EvErrorCard title="Error" contactUsMessage={error?.error?.message} />
				) : (
					issueDetailsBlockComponent
				)}
			</SiteScannerPopup>
		</div>
	);
};
